import { jsx } from "react/jsx-runtime";
import { Text } from "@zillow/constellation-10";
const BlockQuoteContent = ({
  children
}) => /* @__PURE__ */ jsx(Text, { textStyle: "body-lg", css: {
  textAlign: "center",
  display: "block",
  color: "inherit"
}, children });
export {
  BlockQuoteContent as default
};
